<ng-template #VERFCONFIRMATION let-c="close" let-d="dismiss" class="el--popup">
    <app-custom-modal (oncrossBtnClick)="c('Close click');removeVerfication(false)">
        <h4 header> Confirmation </h4>
        <span body *ngIf="!frmScreen && !frmResetDrug">
            <span>
                {{ verfMsg }} verified records exist for this Rx{{ verifiedArray.length > 0 ? '(s): ' + verifiedArray.join(', ') : '.' }}  
                <br/> Do you wish to Re-Verify?
            </span>
            <span  class="text-center" *ngIf="eyconDPVDocsExist"><div><br></div>
                <input class="form-check-input margin_top_0_3rem" type="checkbox" [(ngModel)]="removeEyeconImages" id="removeEyeconImagesCheckbox"/>
                <label class="color_black label-weight" for="removeEyeconImagesCheckbox">
                    Remove <b>Drug Pick</b> Verified Images
                </label>
            </span><div *ngIf="showCopayMessage && rphVerified"><br></div>
            <div class="color_orange font_size_1_2rem transfer-out-msg" *ngIf="showCopayMessage && rphVerified">
                <b>Note: {{msgConfig?.POS_Paid_Transaction_Msg}}</b>
            </div>
        </span>
        <span body *ngIf="frmScreen || frmResetDrug">
            <span [innerHTML]="confirmMessage"></span>
            <span  class="text-center" *ngIf="eyconDPVDocsExist"><div><br></div>
                <input class="form-check-input margin_top_0_3rem" type="checkbox" [(ngModel)]="removeEyeconImages" id="removeEyeconImagesCheckbox"/>
                <label class="color_black label-weight" for="removeEyeconImagesCheckbox">
                    Remove <b>Drug Pick</b> Verified Images
                </label>
            </span><div *ngIf="showCopayMessage && rphVerified"><br></div>
            <div class="color_orange font_size_1_2rem transfer-out-msg" *ngIf="showCopayMessage && rphVerified">
                <b>Note: {{msgConfig?.POS_Paid_Transaction_Msg}}</b>
            </div>
        </span>
        <button footer class="hotkey_primary"
        ngbAutofocus (click)="c('Close click');removeVerfication(true)" (keydown.enter)="c('Close click');removeVerfication(true)" appShortcutKey InputKey="y"><b>Y</b> YES</button>
        <button footer class="hotkey_primary"
        (click)="c('Close click');removeVerfication(false)" (keydown.enter)="c('Close click');removeVerfication(false)" appShortcutKey InputKey="n"><b>N</b> NO</button>
    </app-custom-modal>
</ng-template>
